import type { ResponseDto } from '@app/api/dtos'
import type { MonitoringValidationConfigSpecialCasesDto } from '@app/api/routes/monitoringValidation/dtos'
import type { MonitoringValidationConfigSpecialCasesDataSource } from '@app/types/dataSource'

export const getMonitoringValidationConfigSpecialCasesFromResponse = (
  response?: ResponseDto<MonitoringValidationConfigSpecialCasesDto>
): MonitoringValidationConfigSpecialCasesDataSource[] | undefined => {
  if (!response) return

  const rawData: MonitoringValidationConfigSpecialCasesDto[] | undefined = response?.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    salesOrganizationId: dto?.salesOrganizationId ?? null,
    clusterGroupId: dto?.clusterGroupId ?? null,
    clusterId: dto?.clusterId ?? null,
    competitorNetworkId: dto?.competitorNetworkId ?? null
  }))
}
